import { create } from 'zustand'

import { AuthenticatedUserProfile } from '@sparkai/shared-types'

export interface AuthState {
  token?: string
  setToken: (token: string) => void

  userProfile?: AuthenticatedUserProfile
  setUserProfile: (session: AuthenticatedUserProfile) => void

  setChangingUserScope: (value: boolean) => void
  isChangingUserScope: boolean

  basename?: string
  setBasename: (basename: string) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  token: undefined,
  setToken: (token: string) => set({ token }),
  userProfile: undefined,
  setUserProfile: (userProfile: AuthenticatedUserProfile) => set({ userProfile }),
  isChangingUserScope: false,
  setChangingUserScope: (value: boolean) => set({ isChangingUserScope: value }),
  basename: undefined,
  setBasename: (basename) => {
    set({ basename })
  },
}))
